const Version = {
	version: "3.0.1",
	date: "2026-06-28",
	author: "Tijmen Baas",
	email: "tijmen@devboss.eu",
	releasehash: "AI-Enhanced",
};

const Release = {
	versions: [
		{ "1.0.0": "2022-12-29", update: "Initial release" },
		{ "1.0.1": "2022-12-29", update: "Security update" },
		{ "1.0.2": "2022-12-30", update: "UI updates and bug fixes" },
		{ "1.0.3": "2022-12-30", update: "Cleaned up code" },
		{ "1.0.4": "2022-12-30", update: "Updates navbar and footer" },
		{ "1.0.5": "2023-08-27", update: "Cleaned out console logs" },
		{ "1.0.6": "2024-12-08", update: "Updated multiple screens and added dashboard" },
		{ "2.0.0": "2025-12-13", update: "Major upgrade: Dark mode, keyboard shortcuts, progress indicators, real-time sync, study streaks, achievements system, and UI improvements" },
		{ "2.1.0": "2026-01-24", update: "Added Match Game, Smart Learn Mode, Excel Import and UI improvements" },
		{ "3.0.1": "2026-06-28", update: "Scan output now supports dedicated word list creation (biologie/vak), guided planning, and backend scan metadata improvements." },
		{ "3.0.0": "2026-06-07", update: "Major update: subscription controls, admin access management, Firebase Admin hardening, and production deployment fixes" },
	],
};

const InfoData = { Version, Release };

export default InfoData;
